import React from "react"
import { useTranslation } from "react-i18next"

import { ActionsOverlay } from "shared/ui/actions-overlay/ActionsOverlay"

import { FilteredProductPositionActionHandlers } from "features/product-position-management/model/useProductPositionActionHandlers"
import { useProductPositionActions } from "features/product-position-management/model/useProductPositionActions"

export interface ProductPositionsActionsOverlayViewModel
  extends FilteredProductPositionActionHandlers {
  onClose: () => void
}

export const ProductPositionActionsOverlayView = React.memo(
  ({ onClose, ...handlers }: ProductPositionsActionsOverlayViewModel) => {
    const { t } = useTranslation()
    const { actions } = useProductPositionActions({
      idPrefix: "actions-overlay",
      ...handlers
    })

    return (
      <ActionsOverlay
        id="product-position-actions-overlay"
        headline={t("ProductPosition.Actions.Actions")}
        actions={actions}
        onCancel={onClose}
      />
    )
  }
)
